import { render, staticRenderFns } from "./lists_disposition.vue?vue&type=template&id=31c3118e&scoped=true&"
import script from "./lists_disposition.vue?vue&type=script&lang=ts&"
export * from "./lists_disposition.vue?vue&type=script&lang=ts&"
import style0 from "./lists_disposition.vue?vue&type=style&index=0&id=31c3118e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c3118e",
  null
  
)

export default component.exports